import { InjectionToken } from '@angular/core';

import type { MentionListController } from './types';

export const MENTION_STRATEGY_TOKEN = new InjectionToken<MentionListController>(
  'MENTION_STRATEGY_TOKEN',
);
